"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require("../constants");

var _Actions = require("./Actions");

var _Actions2 = _interopRequireDefault(_Actions);

var _Tail = require("./Tail");

var _Tail2 = _interopRequireDefault(_Tail);

var _useTableMotion = require("../hooks/useTableMotion");

var _useTableMotion2 = _interopRequireDefault(_useTableMotion);

var _ActionBar = require("../ActionBar");

var _ActionBar2 = _interopRequireDefault(_ActionBar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var BULK_ACTIONS_HEIGHT = 56;
var DEFAULT_TRANSITION = {
  duration: 200,
  func: 'ease-in-out',
  delay: 0,
  optimize: false
};
var TRANSITIONS = [_extends({
  prop: 'height'
}, DEFAULT_TRANSITION), _extends({
  prop: 'padding'
}, DEFAULT_TRANSITION)];

var BulkActions = function BulkActions(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      children = _ref.children;
  var motion = (0, _useTableMotion2.default)(TRANSITIONS);
  var positionFixer = _react2.default.Children.count(children) > 1 ? null : _react2.default.createElement("div", {
    className: _constants.ORDER_CLASSNAMES.BULK_CHILD.POSITION_FIXER
  });
  return _react2.default.createElement(_ActionBar2.default, {
    id: _constants.NAMESPACES.BULK_ACTIONS,
    order: _constants.ORDER_CLASSNAMES.BULK,
    className: (0, _classnames2.default)('flex flex-row justify-between bg-action-primary c-on-action-primary br3 br--top ph4', {
      pv4: active
    }),
    style: _extends({
      height: active ? BULK_ACTIONS_HEIGHT : 0,
      overflow: 'hidden'
    }, motion),
    noMargin: true
  }, children, positionFixer);
};

BulkActions.Actions = _Actions2.default;
BulkActions.Tail = _Tail2.default;
exports.default = BulkActions;